import axios from 'axios';
import store  from '../store';

const menu = {
  SearchProduct(search,cancelSource_token) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/search/index.json?query=${search}&supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}`,
      cancelToken: cancelSource_token
    });
  },
  getProductModal() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/products/${store.state.shared.product_id}.json`
    });
  },
  /**
   * Order of the params ${supplier_id}/${service}/${subservice}  all od them are optionals
   * @returns {AxiosPromise}
   */
   //:supplier_id(/:service(/:subservice))
  getProducts() {
    let url = process.env.VUE_APP_CLOUD_PRODUCTS;
    if(!store.state.customer.instance.menu_cached) url = process.env.VUE_APP_API_EXP;
    let serviceUrl = null;
    if (store.state.order.service === 'delivery' && store.state.order.subservice === 'schedule') serviceUrl = 'schedule';
    else serviceUrl = store.state.order.service;
    return axios({
      method: "get",
      url: `${url}/domain_v2/product_suppliers/${store.state.customer.supplier.id}/${serviceUrl}`
    });
  },
  getProductsOld() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/products.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}`
    });
  },
  getCategories() {
    let serviceUrl = store.state.order.service === 'delivery' && store.state.order.subservice === 'schedule' ? 'schedule' : store.state.order.service;
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/categorias.json?supplier_id=${store.state.customer.supplier.id}&service=${serviceUrl}`
    });
  },
  getCategoriesByMain(maincategory_id) {
    let serviceUrl = store.state.order.service === 'delivery' && store.state.order.subservice === 'schedule' ? 'schedule' : store.state.order.service;
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/categorias.json?supplier_id=${store.state.customer.supplier.id}&service=${serviceUrl}&main_category_id=${maincategory_id}`
    });
  },
  getPromos() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/promociones.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}`
    });
  },
  getMainCategories() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/main_categories.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}&subservice=${store.state.order.subservice}`
    });
  },
  getMainCategory(maincategory_id) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/main_categories/${maincategory_id}.json`
    });
  },
  getCategoriesImages() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/categories.json?supplier_id=${store.state.customer.supplier.id}`
    });
  },
  getContentHome(){
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/content_home.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}&subservice=${store.state.order.subservice}`
    });
  },
  getUpsellingProducts(){
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/upselling_products.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}&trigger=precheckout`
    });
  },
  getMasterBanners() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain/v3/sponsor_banners.json?supplier_id=${store.state.customer.supplier.id}`
    });
  },
  getSponsorProducts() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain/v3/suppliers/${store.state.customer.supplier.id}/sponsor_products.json?limit=3`
    });
  }
}

export {
	menu
}
